import httpClient from '@/api/http-client';

const endpoint = 'api/permits-statistics';

const permitStatisticsService = {
  getPermitStatistics: (params) => httpClient.get(endpoint, { params }),

  getPermitStatisticsChartData: (params) => httpClient.get(`${endpoint}-by-year`, { params }),

  getPermitStatusStatistics: (params) => httpClient.get(`${endpoint}-by-status`, { params }),
};
export default permitStatisticsService;
